





























import Vue from 'vue'
import { carAgencyController, carCategoryController } from '~/api/RentalCar'
import AppView from '~/components/AppView.vue'
import Autocomplete from '~/components/Autocomplete.vue'
import { TableHeader } from '~/utils/interfaces'
import { CarCategory, CreateCarCategory } from '~/utils/interfaces/rentalCar'
export default Vue.extend({
  components: { AppView, Autocomplete },
  data() {
    return {
      controller: carCategoryController,
      headers: [
        {
          text: this.$t('name'),
          value: 'name',
        },
        {
          text: this.$t('car_agency'),
          value: 'car_agency_name',
        },
        {
          text: this.$t('actions'),
          value: 'actions',
        },
      ] as TableHeader<CarCategory>[],
      defaultCrud: {
        name: '',
        car_agency: '',
        description: '',
      } as CreateCarCategory,
    }
  },
  methods: {
    getCarAgencies: carAgencyController.getter,
  },
})
